import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { Router } from '@angular/router';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-new-dahsboard-header',
  templateUrl: './new-dahsboard-header.component.html',
  styleUrls: ['./new-dahsboard-header.component.scss']
})
export class NewDahsboardHeaderComponent implements OnInit {
  userType: any;
  adminName: any = '';
  adminEmail: any = '';
  adminImage: string = '';
  notifications: any;
  announcements: any;
  imgUrl = environment.ImageUrl;

  constructor(
    private toastr: ToastrService,
    private router: Router,
    private local: LocalServiceService,
    private auth: AuthServiceService
  ) { }

  ngOnInit(): void {
    let {userType} = this.local.getUser();
    this.userType = userType;

    this.getProfileDetail();
    this.notification_listing();
    this.getMassMessages();
  }

  logout() {
    Swal.fire({
      title: 'Are you sure?',
      text: "You want to logout!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#141631',
      cancelButtonColor: '#e6ba54',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.isConfirmed) {
        this.toastr.success('Logged out successfully');
        this.local.logout();
        this.local.removeAdminData();

        if(this.userType != 'guest') {
          this.router.navigate(['/admin'])
        } else {
          this.router.navigate(['/admin/guest-login'])
        }
      }
    });
  }

  getProfileDetail() {
    this.auth.getProfile().subscribe((response: any) => {
      this.adminName = response.body.userName;
      this.adminEmail = response.body.email;
      // this.adminImage = `https://dev.vvip.com.sg:3011/${response.body.image}`;
    }, (error) => {
      if (error.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
    });
  }

  notification_listing() {
    this.auth.notification_listing().subscribe((response: any) => {
      this.notifications = response.body;
    }, (error) => {
      if (error.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
    });
  }

  downloadReceipt(stripe_invoice_id) {
    if(stripe_invoice_id.trim().length == 0) {
      return this.toastr.error('The receipt cannot be downloaded.')
    }

    this.auth.downloadStripeReceipt(stripe_invoice_id.trim()).subscribe((response: any) => {
      window.open(response.body.hosted_invoice_url, "_blank");
    }, (error) => {
      if(error.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin']);
      }
    });
  }

  getMassMessages() {
    this.auth.getMassMessage().subscribe((response: any) => {
      response.body = response.body.map(e => {
        e.titleLength = e.title.length;
        return e;
      });
      this.announcements = response.body;
    }, (e) => {
      if(e.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
      if(e.status == 400) {
        this.toastr.error(e.error.message)
      }
    });
  }

  openAnnModal(id) {
    let formData = new FormData();
    formData.append("massMessageId", id);
    this.auth.readMassMessage(formData).subscribe((response: any) => {
      let findAnn = this.announcements.find(x => x.id == id);
      let html = ``;
      if(findAnn.image.trim() != '') {
        html += `<img loading="lazy" src="${this.imgUrl}${findAnn.image}" style="border-radius: 4px; width: 80%; margin-top: 20px;">`;
      }
      html += `<p style="padding: 30px 10px 0px 10px; font-weight: 800;">${findAnn.title}</p>
                  <p style="padding: 20px 20px 0px 20px; font-weight: 600;">${findAnn.description}</p>`;
      Swal.fire({
        html: html,
        confirmButtonText: '<i class="fa fa-thumbs-up"></i> Great!'
      })
    }, (e) => {
      if(e.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
      if(e.status == 400) {
        this.toastr.error(e.error.message)
      }
    });
  }

}
